import { Outlet, Route, Routes } from 'react-router-dom';
import type { ProfitAndLossJournalEntriesArgs } from './ProfitAndLossTableCell';
import { ProfitAndLossTable } from './ProfitAndLossTable';
import { useProfitAndLossTableFilter } from './useProfitAndLossTableFilter';

export const ProfitAndLossRoutes = ({
  onOpenJournalEntries,
  children,
}: {
  onOpenJournalEntries?: (args: ProfitAndLossJournalEntriesArgs) => void;
  children?: React.ReactNode;
}) => {
  return (
    <Routes>
      <Route path="*" element={children ?? <Outlet />}>
        <Route
          index
          element={<View onOpenJournalEntries={onOpenJournalEntries} />}
        />
        <Route
          path=":type"
          element={<View onOpenJournalEntries={onOpenJournalEntries} />}
        />
      </Route>
    </Routes>
  );
};

const View = ({
  onOpenJournalEntries,
}: {
  onOpenJournalEntries?: (args: ProfitAndLossJournalEntriesArgs) => void;
}) => {
  const { filter } = useProfitAndLossTableFilter();

  return (
    <ProfitAndLossTable
      key={`profit-and-loss-${filter.type}`}
      onOpenJournalEntries={onOpenJournalEntries}
    />
  );
};
